/**
 * Parses a service center field (e.g. `restrictions`, `theme`) that the
 * backend serializes as a JSON string, tolerating minor formatting issues
 * occasionally emitted by the backend: single quotes instead of double
 * quotes, an extra wrapping quote, or a trailing comma before `}`/`]`
 * (e.g. `..."tutorialLink":"...",}`, which is invalid JSON).
 */
export function safeParseJson(input: any): any {
  if (!input) return {};
  if (typeof input === 'object') return input;
  const s = String(input).trim();
  try {
    return JSON.parse(s);
  } catch (e1) {
    try {
      return JSON.parse(s.replace(/'/g, '"'));
    } catch (e2) {
      try {
        return JSON.parse(s.replace(/^"+|"+$/g, ''));
      } catch (e3) {
        try {
          return JSON.parse(s.replace(/,\s*([}\]])/g, '$1'));
        } catch (e4) {
          console.warn('[safeParseJson] failed to parse', s, e4);
          return {};
        }
      }
    }
  }
}

/** Backend flags an inactive service center via restrictions.inactive === true. */
export function isServiceCenterInactive(restrictions: any): boolean {
  return restrictions?.inactive === true;
}

export const SERVICE_UNAVAILABLE_MESSAGE =
  'Servicio temporalmente en mantenimiento. Estamos realizando mejoras para brindarte una mejor experiencia.';
